<template>
  <header>
    <router-link to="/" class="header-logo">
      <img src="./../assets/n_Logo.svg" />
    </router-link>
    <figure class="userAvatar" v-if="$route.name != 'start_page'">
      <img src="../assets/icons/female-user.svg" alt="User Avatar">
      <figcaption>
        Melanie
      </figcaption>
    </figure>
    <!-- <pre>
    {{ $route.name }}
    ----
    {{ $router.currentRoute.name }}

    -> ist das gleiche!
    </pre> -->

  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    // title: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$headerLogoHeight: 60px;
$headerPadding: 15px;

header{
  position:fixed;
  z-index:100;
  top:0;
  left:0;
  width:100%;
  padding: $headerPadding;
  background:white;
  border-bottom:2px solid var(--color-dark-blue);
  display: flex;
  justify-content: space-between;
  align-items: center;

  .header-logo{
    display: inline-block;

    img{
      display: block;
      height: $headerLogoHeight;

      @media screen and (max-width: 768px){

      }
    }
  }


  .userAvatar{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-right: 10px;

    img{
      display: block;
      height: 35px;
    }

    figcaption{
      font-weight: 600;
      font-size: .75rem;
      margin-top: 5px;
    }
  }
}
</style>
